import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalyticsContext } from '../contexts/AnalyticsContext';

export const usePageTracking = () => {
  const location = useLocation();
  const { trackPageView } = useAnalyticsContext();

  useEffect(() => {
    // Track page view on route change
    trackPageView({
      page_path: location.pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location, trackPageView]);
};
